export default __webpack_public_path__ + "static/media/banner_mis_lentes_2.b77c8157.png";